// Instrument Sans is bundled locally via @fontsource (§4.2: no CDN fonts).
import '@fontsource/instrument-sans/400.css';
import '@fontsource/instrument-sans/500.css';
import '@fontsource/instrument-sans/600.css';
import '@fontsource/instrument-sans/700.css';
import '@brizina/ui-web/src/theme/tokens.css';
import '@brizina/ui-web/src/theme/styles.css';

import { App } from '@brizina/ui-web';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

const root = document.getElementById('root');
if (!root) throw new Error('missing #root');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
